export default {
  signIn: 'Accesso',
  signUp: 'Inizia ora',
  getStarted: 'Iniziare',
};
